import { all, fork } from "redux-saga/effects";
import checkFunctions from "./checkFunctions";
import loginOutFunctions from "./loginOutFunctions";
import signUpFunctions from "./signUpFunctions";

const { checkAuthorization } = checkFunctions;
const { loginRequest, loginSuccess, loginError, logout } = loginOutFunctions;
const { signUpRequest, signUpSuccess, signUpError } = signUpFunctions;

export default function* rootSaga() {
  yield all([
    fork(checkAuthorization),
    fork(loginRequest),
    fork(loginSuccess),
    fork(loginError),
    fork(logout),
    fork(signUpRequest),
    fork(signUpSuccess),
    fork(signUpError)
  ]);
}
